export interface MonitorSettingSelectOption {
    value: number;
    text: string;
}

export interface MonitorSettingTimeZoneOption {
    value: string;
    text: string;
    utcValue: string;
}

export interface BaseDeviceConfig {
    type: string;
    name: string;
    installationNumber: number;
    active: boolean;
}

export interface TritonDeviceConfig extends BaseDeviceConfig {
    channel?: number;
    batteryLowThreshold?: number;
    highLevelThreshold?: number;
    lowLevelThreshold?: number;
    fullPipeThreshold?: number;
    highHighThreshold?: number;
    percent?: number;
    sensitivity?: number;
    flowLossType?: number;
    clearPatternHistory?: boolean;
    rainEnable?: boolean;
    rainThreshold?: number;
    rainReturnToNormal?: number;
    highFlowEnable?: boolean;
    highFlowThreshold?: number;
    overflowEnable?: boolean;
    highHighEnable?: boolean;
    highLevelEnable?: boolean;
    lowLevelEnable?: boolean;
    fullPipeEnable?: boolean;
    flowLossAlarm?: boolean;
    prismdeliveryipaddress?: string;
    prismdeliveryfast?: number;
    prismdeliverynormal?: number;
}

export class MonitorSetting {
    public SampleRateUI?: MonitorSettingSelectOption[];
    public DataLogMode?: MonitorSettingSelectOption[];
    public TimeZone?: MonitorSettingTimeZoneOption[];
    public NormalRate?: MonitorSettingSelectOption[];
    public FastRate?: MonitorSettingSelectOption[];
    public rainExceedingFlag?: boolean;
    public samplerate?: number;
    public rainpertip?: number;
    public logintensity?: boolean;
    public logukintensity?: boolean;
    public datalogmode?: number;
    public intensityinterval?: number;
    public timezone?: string;
    public usedaylightsaving?: boolean;
    public datadeliveryipaddress?: string;
    public datadeliverynormalrate?: number;
    public datadeliveryfastrate?: number;
    public alarmenable?: boolean;
    public serialnumber?: string;
    public locationid?: number;
    public ipaddress?: string;
    public alarmthreshold?: number;
    public isRainIntensity = false;
    public fastrate?: number;
    public scanRate?: number;
    public manholedepth?: number;
    public physicaloffset?: number;
    public unidepthtoaverage?: number;
    public lowlevelenable?: boolean;
    public lowlevelthreshold?: number;
    public fullpipeenable?: boolean;
    public highlevelenable?: boolean;
    public highlevelthreshold?: number;
    public highhighenable?: boolean;
    public highhighthreshold?: number;
    public overflowenable?: boolean;
    public tiltenable?: boolean;
    public tiltthreshold?: number;
    public batterylowenable?: boolean;
    public batterylowthreshold?: number;
    public datadeliverynormal?: number;
    public datadeliveryfast?: number;
    public echoFastRate?: MonitorSettingSelectOption[];
    public echoNormalRate?: MonitorSettingSelectOption[];
    public echoDataFastRate?: MonitorSettingSelectOption[];
    public monitorSeries?: string;
    public pipeHeight?: number;
    public customerId?: number;
    public alarmreturntonormal?: number;
    public storetemperature?: boolean;
    public storeBatteryVoltageUI?: MonitorSettingSelectOption[];
    public storebattery?: number;
    public modem?: boolean;
}

export interface MonitorAddLocationSelectable {
    monitorSeriesID: MonitorIdentifier;
    value: string;
    text: string;
}

export interface LocationCardMonitorSeries {
    monitorSeriesID: MonitorIdentifier;
    value: string;
    text: string;
    batteryLowInt?: number;
}

export enum MonitorIdentifier {
    None = 0,
    Unknown,
    FlowAlert,
    RainAlertII,
    Gateway,
    FlowShark = 5,
    FlowSharkIS,
    FlowSharkRT,
    OneThousandFiveHundredTwo,
    OneThousandFiveHundredTwoEM,
    OneThousandFiveHundredSix = 10,
    ThreeThousandFiveHundre,
    ThreeThousandFiveHundreS,
    ThreeThounsandSixHundred,
    FourThousand,
    FourThousandFiveHundred = 15,
    FourThousandFiveHundredS,
    FiveThousandFiveHundred,
    FiveThousandSixHundred,
    SevenThousandFiveHundredTen,
    SevenThousandFiveHundredTenPlus = 20,
    Triton,
    FlowHawk,
    ThreeThousand,
    TwoThousand,
    TritonIM = 25,
    TritonPlus,
    RU33,
    LeakTest,
    RainAlertIII,
    Pulse = 30,
    Echo,
    ICE3,
    USGS,
    ForeSITE_UL = 34,
    ForeSITE_XD,
    FLEX,
    Generic,
    EdgeRl,
    EdgeDx = 39,
}

export interface RainAlertConfiguration {
    rainpertip?: number;
    logintensity?: boolean;
    logukintensity?: boolean;
    datalogmode?: number;
    intensityinterval?: number;
    alarmenable?: boolean;
    alarmthreshold?: number;
    alarmreturntonormal?: number;
    serialnumber?: string;
    ipaddress?: string;
    fastRate?: number;
    scanRate?: number;
    locationid?: number;
    samplerate?: number;
    timezone?: string;
    usedaylightsaving?: boolean;
    prismdeliveryipaddress?: string;
    prismdeliverynormal?: number;
    prismdeliveryfast?: number;
    storetemperature?: boolean;
    storebattery?: number;
    connectionType?: number;
    synctime?: boolean;
    modem?: boolean;
    apn?: string;
}

export interface EchoConfiguration {
    fastrate?: number;
    manholedepth?: number;
    pipeheight?: number;
    physicaloffset?: number;
    unidepthtoaverage?: number;
    lowlevelenable?: boolean;
    lowlevelthreshold?: number;
    fullpipeenable?: boolean;
    highlevelenable?: boolean;
    highlevelthreshold?: number;
    highhighenable?: boolean;
    highhighthreshold?: number;
    overflowenable?: boolean;
    tiltenable?: boolean;
    tiltthreshold?: number;
    batterylowenable?: boolean;
    batterylowthreshold?: number;
    serialNumber?: string;
    ipaddress?: string;
    blanking?: number;
    power?: number;
    compensatedTemperatureMarch?: number;
    compensatedTemperatureSeptember?: number;
    pressureStore?: boolean;
    storeData?: boolean;
    temperatureSensor?: number;
    gainControl?: number;
    electronicOffset?: number;
    unidepthFiltering?: boolean;
    hc?: number;
    silt?: number;
    locationid?: number;
    samplerate?: number;
    timezone?: string;
    usedaylightsaving?: boolean;
    prismdeliveryipaddress?: string;
    prismdeliverynormal?: number;
    prismdeliveryfast?: number;
    storetemperature?: boolean;
    storebattery?: number;
    connectionType?: number;
    synctime?: boolean;
    modem?: boolean;
    apn?: string;
}

export enum ConfirmationType {
    LocationDashboard,
    DataCollection,
    ScheduleCollection,
    Close,
    LocationExport,
}

export interface TritonConfiguration {
    fastrate?: number;
    manholedepth?: number;
    pipeheight?: number;
    physicaloffset?: number;
    unidepthtoaverage?: number;
    highlevelthreshold?: number;
    highhighenable?: boolean;
    highhighthreshold?: number;
    overflowenable?: boolean;
    tiltenable?: boolean;
    tiltthreshold?: number;
    batterylowenable?: boolean;
    batterylowthreshold?: number;
    serialNumber?: string;
    ipaddress?: string;
    locationid?: number;
    samplerate?: number;
    timezone?: string;
    usedaylightsaving?: boolean;
    datadeliveryipaddress?: string;
    datadeliverynormal?: number;
    datadeliveryfast?: number;
    storetemperature?: boolean;
    storebattery?: number;
    lowlevelenable?: boolean;
    lowlevelthreshold?: number;
    modem?: boolean;
    fullpipeenable?: boolean;
    highlevelenable: boolean;
    prismdeliveryipaddress: string;
    prismdeliverynormal: number;
    prismdeliveryfast: number;
    ftpdeliverynormal: number;
    ftpdeliveryfast: number;
    ftpfolder: string;
    ftppassword: string;
    ftpusername: string;
    ftpserver: string;
    ftpmode: string;
    ftpformat: string;
    devices: TritonDeviceConfig[];
    synctime?: boolean;
    silts: number[];
    comport: string;
    inclinometerthreshold: number;
    apn?: string;

    compensatedTemperatureMarch?: number;
    compensatedTemperatureSeptember?: number;
    rainpertip?: number;

}


export type ActivateLocationResponse = string | {
    responseMessage: string;
}
